export default {
    amount: "Quantidade",
    price: "Preço",
    apply_monthly_change_now: "Aplicar diferença esse mês",
    update_button: "Atualizar",
    description: "Descrição",
    total: "Total",
    cost_per_tool: "Custo por Ferramenta",
    see_all_costs: "Ver todos ({count})",
    credit: "Crédito",
    credits: "Créditos",
    no_cost_available:
        "Nenhum custo disponível, pois este estabelecimento ainda não possui um plano de créditos.",
    add_plan: "Adicionar um Plano",
    next_recharge: "Próxima recarga:",
    credits_in: "créditos em",
    recharge_history: "Histórico de recargas",
    balance: "Saldo",
    month_year: "Mês / Ano",
    expired: "Vencidos",
    available: "Disponível",
    expiration: "Vencimento",
    monthly_plan: "Plano Mensal",
    monthly_adjustment: "Ajuste Plano Mensal",
    extra_package: "Pacote Extra",
    not_informed: "Não informado",
    monthly_plan_updated: "Plano mensal atualizado",
    page_title: "Créditos",
    load_error: "Ocorreu um erro ao carregar os dados financeiros da sua conta. Por favor, tente recarregar a página.",
    usage_history_error: "Não foi possível carregar o histórico de uso no momento.",
    not_enough_data: "Não há dados suficientes para o período.",
    data_load_error: "Ocorreu um erro ao carregar os dados. Por favor, tente novamente.",
    no_active_package: "Nenhum pacote de créditos ativo no momento.",
    current_balance: "Saldo atual",
    credit_options: "Opções de crédito",
    adjust_monthly_package: "Ajustar Pacote Mensal",
    no_data_for_period: "Nenhum dado para o período",
    consumption_by_action: "Consumo por ação:",
    action: "Ação",
    no_consumption_for_period: "Nenhum consumo registrado no período.",
    usage_history_title: "Histórico de uso:",
    detailed_usage_statement: "Extrato Detalhado de Uso",
    total_records_found: "Total de registros encontrados no período: {count}",
    automation_campaign: "Automação/Campanha",
    credits_consumed: "Créditos Consumidos",
    no_records_found: "Nenhum registro encontrado no período.",
    next: "Próxima",
    previous: "Anterior",
    no_changes_detected: "Nenhuma alteração detectada",
    price_difference_charged: "Valor cobrado pela diferença: {amount}",
    generating_invoice: "Fatura gerada! Abrindo WhatsApp...",
    error_processing_invoice: "Erro ao processar solicitação da fatura.",
    server_communication_error: "Falha na comunicação com o servidor.",
    whatsapp_msg_intro: "Olá! Tenho uma solicitação de crédito:",
    whatsapp_msg_establishment: "Estabelecimento: {name}",
    whatsapp_msg_requester: "Solicitante: {name}",
    whatsapp_msg_details_adjust: "Solicitação: Ajustar Pacote Mensal para {credits} créditos",
    whatsapp_msg_details_extra: "Solicitação: Pacote Extra de {credits} créditos",
    contract_button: "Contratar",
    inform_credits_amount: "Informe a quantidade de créditos desejada",
    credits_added_success: "Créditos adicionados com sucesso!",
    error_processing_request: "Erro ao processar solicitação.",
    credits_statement: "Extrato",
    loading_data: "Carregando dados...",
    automation: "Automação",
    campaign: "Campanha",
    page_x_of_y: "Página {current} de {total}",
    close: "Fechar",
    manage_credits: "Gerenciar créditos",
    view_recharge_history: "Visualizar histórico de recargas",
    consumption_estimated_end_month: "Consumo estimado até o fim do mês: {amount} créditos",
    no_credits_available: "Você não possui mais créditos disponíveis",
    expires_in: "Vence em",
    next_packages_available: "Próximos pacotes disponíveis",
    view_full_history: "Ver histórico completo",
    group_daily: "Diário",
    group_weekly: "Semanal",
    group_monthly: "Mensal",
    group_quarterly: "Trimestral",
    period_too_long_daily: "Período muito longo para visão diária",
    period_too_long_weekly: "Período muito longo para visão semanal",
    period_too_short_weekly: "Selecione ao menos 2 semanas para a visão semanal",
    period_too_short_monthly: "Selecione ao menos 2 meses para a visão mensal",
    period_too_short_quarterly: "Selecione ao menos 6 meses para a visão trimestral",
    tooltip_others: "Outras ({count} automações)",
    daily_average: "Média diária: {amount} créditos",
    consumption_by_branch: "Consumo por filial:",
    consumption_by_category: "Consumo por categoria:",
    no_automation_found: "Nenhuma automação ou campanha encontrada no período.",
    action_type_manual: "Ajuste Manual",
    action_type_other: "Outros",
    download_csv: "Baixar CSV",
    date_time: "Data/Hora",
    credits_consumption: "Consumo de Créditos",
    expires_at_small: "vence",
    load_statement_error: "Erro ao carregar os dados de extrato.",
    prepare_csv_error: "Erro ao preparar exportação CSV.",
    no_branch: "Sem filial",
    other: "Outros",
    // Filter labels
    filter_by_date: "Filtrar por data",
    action_type_filter: "Tipo de ação",
    all_actions: "Todas as ações",
    automations_filter: "Automações",
    campaigns_filter: "Campanhas",
    in_automations: "Em automações:",
    in_campaigns: "Em campanhas:",
    total_consumed: "Total de créditos consumidos:",
    status_filter: "Status",
    active: "Ativos",
    inactive: "Inativos",
    segments: "Segmentos",
    // Package labels
    consumed: "consumido",
    used: "usado",
    credit_package: "Pacote de créditos",
    monthly_package_label: "Pacote Mensal",
    single_package_label: "Pacote Avulso",
    monthly_partial_label: "Ajuste Mensal",
    // Notifications
    monthly_plan_updated: "Plano atualizado",
    monthly_plan_update_error: "Erro ao atualizar plano",
    balance_load_error: "Erro ao carregar os dados de saldo. Por favor, recarregue a página.",
    // Misc
    date: "Data",
    action_type_other: "Outros",
    unknown: "Desconhecido",
    expand_chart: "Expandir gráfico",
    category: "Categoria",
    trigger: "Gatilho",
    action_type_whatsapp: "WhatsApp",
    action_type_whatsapp_api: "WhatsApp (API)",
    action_type_sms: "SMS",
    action_type_rcs: "RCS",
    action_type_email: "E-mail",
    action_type_ai: "IA",
    action_type_task: "Tarefas",
    action_type_task_ai: "Tarefa com IA",
    action_type_webhook: "WebHook",
    action_type_ai_basic: "IA Básica",
    action_type_ai_advanced: "IA Avançada",
    action_type_ai_gpt5: "IA Avançada (GPT-5)",
    action_type_ai_selection: "Seleção por IA",
    action_type_smart_insertion: "Inserção Inteligente",
    action_type_plugin: "Ação de Plugin",
    action_type_automation: "Automação",
    trigger_birthday: "Aniversário",
    trigger_specific_date: "Data Específica",
    trigger_registration: "Cadastro",
    trigger_purchase: "Compra",
    trigger_points: "Pontos Acumulados",
    trigger_inactivity: "Inatividade",
    view_full_statement: "Ver extrato completo",
    back_to_credits: "Voltar para Créditos",
    credit_statement_title: "Extrato de Créditos",
    credit_statement_subtitle: "Confira seus créditos em detalhe",
    load_periods_error: "Ocorreu um erro ao carregar os períodos disponíveis. Por favor, tente recarregar a página.",
    no_statement_available: "Nenhum extrato disponível no momento.",
    period_colon: "Período:",
    select_month_placeholder: "Selecione o mês desejado...",
    usage_details: "Detalhes do Uso",
    consumed_value: "Valor Consumido",
    linked_client_id: "ID Cliente Vinculado",
    credit_type: "Tipo de Crédito",
    execution_id: "ID Execução",
    no_transactions_for_month: "Nenhuma transação encontrada para {month}."
};
